import { render, staticRenderFns } from "./product-related.vue?vue&type=template&id=545612d1&"
import script from "./product-related.vue?vue&type=script&lang=js&"
export * from "./product-related.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/cinderellamaecuya/SP/peppermayo-astro/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('545612d1')) {
      api.createRecord('545612d1', component.options)
    } else {
      api.reload('545612d1', component.options)
    }
    module.hot.accept("./product-related.vue?vue&type=template&id=545612d1&", function () {
      api.rerender('545612d1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/components/product-related.vue"
export default component.exports